import { atom } from 'nanostores';
import { getConfiguredApolloClient } from '@/libs/graphql/client';
import { PatientWalletByFirebaseUidDocument } from '../graphql/queries/patientWalletByFirebaseUid.generated';

export type Patient = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
};

export type Address = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
};

export const patientWalletBalance = atom<number | null>(null);
export const billingAddress = atom<Address | null>(null);
export const patient = atom<Patient | null>(null);
export const shippingAddress = atom<Address | null>(null);

export const getPatientWalletBalance = async (patientInput) => {
  try {
    const client = getConfiguredApolloClient({
      Authorization: `Bearer ${patientInput.idToken}`,
      app: 'patient-portal',
      currentworkspace: patientInput.workspaceId,
    });
    const { data } = await client.mutate({
      mutation: PatientWalletByFirebaseUidDocument,
      variables: {
        uid: patientInput.firebaseUid,
        workspaceId: patientInput.workspaceId,
      },
    });

    if (data && data.patientWallet && data.patientWallet.length > 0) {
      patientWalletBalance.set(data?.patientWallet[0]?.balance);
      const foundBillingAddress =
        data?.patientWallet[0]?.patient?.patientAddresses?.find(
          (address) => address.type === 'BILLING' || 'billing'
        );
      const foundShippingAddress =
        data?.patientWallet[0]?.patient?.patientAddresses?.find(
          (address) => address.isShipping
        );
      if (foundBillingAddress) {
        const { addressLine1, addressLine2, city, id, state, zipCode } =
          foundBillingAddress.address;
        billingAddress.set({
          addressLine1,
          addressLine2,
          city,
          state,
          zipCode,
        });
      }

      if (foundShippingAddress) {
        const { addressLine1, addressLine2, city, id, state, zipCode } =
          foundShippingAddress.address;
        shippingAddress.set({
          addressLine1,
          addressLine2,
          city,
          state,
          zipCode,
        });
      }

      patient.set(data?.patientWallet[0]?.patient?.patientWorkspaces?.[0]);
    }

    return data;
  } catch (err) {
    console.log(err, 'err');
  }
};

export function setPatient(w) {
  patient.set(w);
}
